import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Menu, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import logo from "../assets/logo-applaby.png";
import BlogFooter from "./blog/BlogFooter";

const posts = [
	{
		slug: "digitalizar-restaurante",
		title: "Cómo digitalizar tu restaurante y aumentar tus reservas",
		excerpt:
			"Descubre los pasos para transformar tu restaurante en una experiencia digital.",
		image: "https://source.unsplash.com/600x400/?restaurant",
		date: "2025-09-15",
	},
	{
		slug: "beneficios-app",
		title: "Beneficios de tener tu propia app",
		excerpt:
			"Notificaciones push, fidelización y más ventajas para tu negocio.",
		image: "https://source.unsplash.com/600x400/?mobile,app",
		date: "2025-09-15",
	},
	{
		slug: "errores-digitalizacion",
		title: "Errores comunes al digitalizar un negocio (y cómo evitarlos)",
		excerpt:
			"Muchos negocios cometen fallos al dar el salto digital. Aprende cuáles son y cómo evitarlos para no perder clientes.",
		image: "https://source.unsplash.com/600x400/?business,digital",
		date: "2025-09-20",
	},
	{
		slug: "reservas-online",
		title: "Por qué las reservas online son clave para tu negocio",
		excerpt:
			"Los clientes ya no quieren llamar por teléfono: descubre cómo las reservas online transforman tu negocio y fidelizan más.",
		image: "https://source.unsplash.com/600x400/?calendar,booking",
		date: "2025-09-21",
	},
	{
		slug: "checklist-digitalizacion",
		title: "Checklist de digitalización: ¿está tu negocio preparado?",
		excerpt:
			"Una guía práctica con los puntos clave para saber si tu negocio está listo para dar el salto digital con éxito.",
		image: "https://source.unsplash.com/600x400/?checklist,planning",
		date: "2025-09-22",
	},
];

export default function BlogList() {
	const [menuOpen, setMenuOpen] = useState(false);
	const { t } = useTranslation();

	return (
		<div className="font-poppins">
			<Helmet>
				<title>{t("seo.blog.title")}</title>
				<meta name="description" content={t("seo.blog.description")} />
				<link rel="canonical" href="https://applaby.com/blog" />
			</Helmet>

			<header className="fixed top-0 left-0 w-full bg-white border-b border-gray-100 shadow-sm z-50">
				<div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
					<Link to="/" className="flex items-center gap-2">
						<img src={logo} alt="Applaby" className="h-8" />
					</Link>

					<nav className="hidden md:flex items-center gap-6 text-sm font-medium text-gray-600">
						<a href="/" className="hover:text-[#43BD98] transition">
							Inicio
						</a>
						<a href="/#precios" className="hover:text-[#43BD98] transition">
							Precios
						</a>
					</nav>

					<button
						className="md:hidden text-gray-600"
						onClick={() => setMenuOpen(!menuOpen)}
					>
						{menuOpen ? <X size={24} /> : <Menu size={24} />}
					</button>
				</div>

				{menuOpen && (
					<div className="md:hidden bg-white border-t border-gray-100 shadow-sm">
						<nav className="flex flex-col px-6 py-4 gap-4 text-sm font-medium text-gray-600">
							<a href="/" className="hover:text-[#43BD98] transition">
								Inicio
							</a>
							<a href="/#precios" className="hover:text-[#43BD98] transition">
								Precios
							</a>
						</nav>
					</div>
				)}
			</header>

			<div className="h-16" />

			<div className="bg-[#f8fefc] border-b border-gray-100">
				<div className="max-w-6xl mx-auto px-6 py-16 text-center">
					<p className="text-sm font-semibold text-[#43BD98] uppercase tracking-wide mb-2">
						Blog Applaby
					</p>
					<h1 className="text-3xl md:text-4xl font-extrabold text-gray-900">
						Consejos y guías para tu negocio
					</h1>
					<p className="text-gray-600 mt-3 max-w-2xl mx-auto">
						Aprende cómo digitalizar tu negocio, fidelizar clientes y crecer con
						herramientas profesionales.
					</p>
				</div>
			</div>

			<div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10">
				{posts.map((post) => (
					<Link
						key={post.slug}
						to={`/blog/${post.slug}`}
						className="group bg-white border border-gray-100 rounded-2xl shadow-sm hover:shadow-lg transition p-6 flex flex-col justify-between"
					>
						<div>
							<h2 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#43BD98] transition">
								{post.title}
							</h2>
							<p className="text-gray-600 text-sm leading-relaxed">
								{post.excerpt}
							</p>
						</div>
						<div className="mt-6 text-xs text-gray-400">
							{new Date(post.date).toLocaleDateString("es-ES", {
								year: "numeric",
								month: "long",
								day: "numeric",
							})}
						</div>
					</Link>
				))}
			</div>

			<BlogFooter />
		</div>
	);
}
